"use client";

import { useEffect, useState } from "react";
let hasAppRendered = false;

export function Loader() {
  const [shouldRender, setShouldRender] = useState(!hasAppRendered);
  const [isLoaded, setIsLoaded] = useState(hasAppRendered);

  useEffect(() => {
    if (hasAppRendered) return;

    // A unified delay ensuring initial intro plays correctly across all routes
    const delay = 1000;

    const timer = setTimeout(() => {
      setIsLoaded(true);
      setTimeout(() => {
        setShouldRender(false);
        hasAppRendered = true; // Store in memory so soft navigations don't retrigger
      }, 1000); // Wait for transition
    }, delay);

    return () => clearTimeout(timer);
  }, [shouldRender]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-90 flex items-center justify-center ${
        isLoaded
          ? "invisible transition-[visibility] duration-300 delay-1000"
          : ""
      }`}
    >
      {/* Spinner */}
      <div
        className={`relative w-25 h-25 rounded-full border-3 border-transparent border-t-[lime] animate-[spin_2s_linear_infinite] z-100 ${
          isLoaded ? "opacity-0 transition-opacity duration-300" : ""
        }
        before:content-[''] before:absolute before:inset-1.25 before:rounded-full before:border-3 before:border-transparent before:border-t-[red] before:animate-[spin_3s_linear_infinite]
        after:content-[''] after:absolute after:inset-3.75 after:rounded-full after:border-3 after:border-transparent after:border-t-[gold] after:animate-[spin_1.5s_linear_infinite]`}
      />

      {/* Left Curtain */}
      <div
        className={`fixed top-0 left-0 w-[51%] h-full bg-(--bg-card) z-90 transition-transform duration-700 delay-300 ease-[cubic-bezier(0.645,0.045,0.355,1)] ${
          isLoaded ? "-translate-x-full" : "translate-x-0"
        }`}
      />

      {/* Right Curtain */}
      <div
        className={`fixed top-0 right-0 w-[51%] h-full bg-(--bg-card) z-90 transition-transform duration-700 delay-300 ease-[cubic-bezier(0.645,0.045,0.355,1)] ${
          isLoaded ? "translate-x-full" : "translate-x-0"
        }`}
      />
    </div>
  );
}
